import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArtboardIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.22 19.84H4.12V4.08H19.88V15.18L15.22 19.84ZM5.96 5.92V18H13.82V13.78H18.04V5.92H5.96Z" />
    </SvgIcon>
  );
});
